import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    const role = localStorage.getItem("liveq_google_role") || "fan";
    localStorage.removeItem("liveq_google_role");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, role });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.role === "streamer" ? "/dashboard" : "/descubrir", { replace: true });
      } catch {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/auth", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div data-testid="auth-callback" className="p-16 text-center text-zinc-500">...</div>;
}
